import React, {useMemo} from "react";
import {useIntl} from "react-intl";
import useLinkHandler from "../../../hook/useLinkHandler";
import PageWrapper from "../../../component/home/HomeContentPage";
import {HomeContentId} from "../../../component/home/variable/HomeContentType";
import * as Page from "../../../component/home/HomeContentPage";
import classNames from "classnames";
import HorizontalVideo from "../../../assets/videos/sample_horizontal.mp4";
import VerticalVideo from "../../../assets/videos/smaple_vertical.mp4";

const HeroPage: React.FC = () => {
    const intl = useIntl();
    const { linkToFreeOnboarding } = useLinkHandler();

    const onClickFreeSubscription = () => {
        linkToFreeOnboarding();
    }

    const gradient = useMemo(() => {
        return {
            pink: (
                <div className={"w-full h-full"}
                     style={{
                         background: "linear-gradient(180deg, rgba(235, 0, 255, 0.12) 0%, rgba(140, 49, 185, 0.12) 69.5%, rgba(99, 70, 155, 0.12) 100%)",
                         filter: "blur(150px)"
                     }} />
            ),
            purple: (
                <div className={"w-full h-full"}
                     style={{
                         borderRadius: 421,
                         background: "linear-gradient(180deg, rgba(138, 94, 255, 0.00) 0%, rgba(68, 26, 152, 0.25) 100%)",
                         filter: "blur(100px)"
                     }} />
            )
        }
    }, [])

    return (
        <PageWrapper scrollId={HomeContentId.HERO} className={"mt-[144px] lg:mt-[88px]"}>
            <div className={"order-2 lg:order-1 z-10"}>
                <Page.MainHeading>
                    {intl.formatMessage({id: "i0013"})}
                </Page.MainHeading>
                <Page.MainDescription className={"mt-[16px]"}>
                    {intl.formatMessage({id: "i0014"})}
                </Page.MainDescription>
                <div className={classNames("w-fit h-fit flex justify-center items-center px-[24px] py-[16px]",
                    "bg-[#FFFFFF] rounded-[8px] border border-bunny-gray-400 cursor-pointer mt-[40px]")}
                     onClick={onClickFreeSubscription}
                >
                    {intl.formatMessage({id: "i0015"})}
                </div>
            </div>
            <div className={"relative w-[505px] aspect-[505/488] order-1 lg:order-2"}>
                <div className={"w-[649px] h-[633px] rotate-[104.5deg] absolute top-[-347px] right-[-254px]"}>
                    {gradient.pink}
                </div>
                <div className={"w-[421px] h-[421px] absolute bottom-[-38px] right-[133px]"}>
                    {gradient.purple}
                </div>
                <video src={HorizontalVideo} width={"90.5%"} height={"62.5%"} autoPlay muted loop
                       className={"absolute top-0 right-0 rounded-[8px] shadow-[0_54px_64px_-22px_rgba(110,102,126,0.38)]"} />
                <video src={VerticalVideo} width={"51%"} height={"70%"} autoPlay muted loop
                       className={"absolute bottom-0 left-0 rounded-[8px] border border-[#E7E7E7] shadow-[0_54px_64px_-22px_rgba(110,102,126,0.38)]"} />
            </div>
        </PageWrapper>
    )
}

export default HeroPage;
